import React from 'react';
import { Text, Preset, Color } from '@lux/text';
import { Button } from './styles';
export var SubCategory = function (_a) {
    var _b;
    var category = _a.category, toggleSelection = _a.toggleSelection, selectedCategoriesSet = _a.selectedCategoriesSet, availableCategoriesSet = _a.availableCategoriesSet, closeFilterModal = _a.closeFilterModal;
    var isOneOfChildrenActive = (_b = category === null || category === void 0 ? void 0 : category.categories) === null || _b === void 0 ? void 0 : _b.reduce(function (t, c) { return t || selectedCategoriesSet.has(c.id); }, false);
    var isActive = selectedCategoriesSet.has(category.id) || isOneOfChildrenActive;
    var isAvailable = availableCategoriesSet.has(category.id);
    var onClick = function () {
        if (!selectedCategoriesSet.has(category.id)) {
            toggleSelection(category.id, 3);
            closeFilterModal();
        }
    };
    return (React.createElement(Button, { onClick: onClick, type: "button", "aria-pressed": isActive },
        React.createElement(Text, { preset: Preset.S, color: isActive && isAvailable ? Color.primary : Color.dark, bold: isActive && isAvailable }, category.name)));
};
export default SubCategory;
